/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { RevokeWhatsAppAuthorizationTokenResponse } from '../models/RevokeWhatsAppAuthorizationTokenResponse';
import type { WhatsAppCSRFTokenRequest } from '../models/WhatsAppCSRFTokenRequest';
import type { WhatsAppOAuthRequest } from '../models/WhatsAppOAuthRequest';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class WhatsAppService {

    /**
     * Revokes the WhatsApp authorization token on behalf of an user.
     * @param organizationId The ID of the organization to scope the integrations for.
     * @returns RevokeWhatsAppAuthorizationTokenResponse OK
     * @throws ApiError
     */
    public static revokeWhatsAppAuthorizationToken(
        organizationId: string,
    ): CancelablePromise<RevokeWhatsAppAuthorizationTokenResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/integrations/organizations/{organizationId}/whatsapp/revokeAuthToken',
            path: {
                'organizationId': organizationId,
            },
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static storeWhatsAppCsrfToken(
        requestBody?: WhatsAppCSRFTokenRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/integrations/whatsapp/storeWhatsAppCSRFToken',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * Meta (WhatsApp) webhook endpoint — verifies and receives messages.
     * @returns any OK
     * @throws ApiError
     */
    public static verifyWhatsAppWebhook(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/integrations/whatsapp/webhook',
        });
    }

    /**
     * @returns any OK
     * @throws ApiError
     */
    public static whatsAppWebhook(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/integrations/whatsapp/webhook',
            errors: {
                400: `Bad Request`,
            },
        });
    }

    /**
     * @returns string OK
     * @throws ApiError
     */
    public static getWhatsAppBusinessAccounts(): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/integrations/whatsapp/businessAccounts',
            errors: {
                404: `Not Found`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns any OK
     * @throws ApiError
     */
    public static authorizeWhatsApp(
        requestBody?: WhatsAppOAuthRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/integrations/whatsapp/getAccessToken',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
            },
        });
    }

}
